module.exports = __webpack_public_path__ + "fonts/GoblinOne.bf7b2654.woff2";